// Default max variants limit for all shops
export const STORE_MAX_VARIANTS_LIMIT = 10000;

// Store variant limit overrides for specific shops (future-proof for more cases)
// Add new entries here as needed: { domain: "xxx.myshopify.com", limit: 20000 }
export const STORE_MAX_VARIANTS_LIMIT_OVERRIDES = [
  { domain: "28958b.myshopify.com", limit: 20000 },
  { domain: "wfaqa1-wa.myshopify.com", limit: 20000 },
];

/**
 * Returns the appropriate store max variants limit based on the shop domain.
 * Shops in the override list can have a higher limit (e.g. 20000), all others get the default (10000).
 * 
 * @param {string|null} shop - The shop domain (e.g., "28958b.myshopify.com")
 * @returns {number} The max variants limit for the given shop domain
 */
export const getStoreMaxVariantsLimitForShop = (shop) => {
  if (!shop) return STORE_MAX_VARIANTS_LIMIT;
  const override = STORE_MAX_VARIANTS_LIMIT_OVERRIDES.find(
    (specialCaseShop) => specialCaseShop.domain === shop
  );
  return override?.limit ?? STORE_MAX_VARIANTS_LIMIT;
};

// Billing plan feature name for Create Chrome PO.
export const CREATE_CHROME_PO_FEATURE_NAME_IN_BILLING_PLAN = "PurchaseOrder";

// Show Create Shopify PO only when PurchaseOrder is present in billing plan features with status=true.
export const billingPlanHasPurchaseOrderFeature = (billingPlan) =>
  billingPlan?.features?.some(
    (feature) =>
      feature?.name === CREATE_CHROME_PO_FEATURE_NAME_IN_BILLING_PLAN &&
      feature?.status === true
  ) === true;

//Billing Plan Page Constants

export const PAID_PLANS_STATUS = '1';
export const PRO_PLAN_STATUS = '2';
export const CHANGE_PLAN_STATUS = 'change_plan';
export const FORECAST_REPORT_TYPE_URL_PARAM = 'SelectedforecastReportType';
export const OVERSTOCK_FORECAST_REPORT_TYPE = 'overstock';
export const BESTSELLERS_FORECAST_REPORT_TYPE = 'bestSellers';
export const DEFAULT_FORECAST_REPORT_TYPE = 'default';

//Used if we want to display a popup above every other element
export const MAX_Z_INDEX_VALUE = 2147483647;


export const UPGRADE_TO_FORECASTING_PRO_PLAN_LINK = `/ui/onboarding/billingplan?status=${PRO_PLAN_STATUS}`;
export const CHANGE_BILLING_PLAN_LINK = `/ui/onboarding/billingplan?status=change_plan`;

export const SUBSCRIPTION_COPY = {
  cancelEntry: "Cancel subscription",
  cancelTitle: "Cancel your subscription?",
  cancelBody:
    "You will lose access to the app immediately. Your data is kept for a short period in case you change your mind.",
  cancelConfirm: "Cancel subscription",
  cancelKeep: "Keep my plan",
  cancelError: "Could not cancel the subscription.",
  inactiveTitle: "Your subscription is not active",
  inactiveBody:
    "To keep using the app, choose a plan. If you no longer want the app, please uninstall it from your Shopify admin.",
  choosePlan: "Choose a plan",
  uninstall: "Uninstall app",
};
export const DOWNGRADE_BILLING_PLAN_LINK = `/ui/onboarding/downgradeplan`;

export const IFH_CHROME_EXTENSION_WEBSTORE_LINK = 'https://chromewebstore.google.com/detail/shopify-toolkit-by-ifh/kblmmfigdijhnjhehelmhkcgcjboopbk'

export const CALENDLY_SCHEDULE_CALL_LINK  = 'https://calendly.com/customer-success-storebuilder/app-onboarding-demo?month=2026-06';

export const DISPLAY_ARRIVAL_DATES_DEMO_VIDEO_URL = "https://youtu.be/Olpb9a9n_FI?si=yt21kvV-cjAXqdba";  

// Chrome Extension – Purchase Order related constants
export const IFH_PO_PRODUCTS_LOCAL_STORAGE_KEY = "IFH_PO_PRODUCTS";
export const IFH_APP_ORIGIN = "https://app.iforecasthero.com";
export const IFH_PO_PRODUCTS_READY_MESSAGE_TYPE = "IFH_PO_PRODUCTS_READY";
export const IFH_PO_FALLBACK_POPUP_ELEMENT_ID = "PopupForFallbackLinkToOpenPo";